import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { baseURL } from "../../../App";
import axios from "axios";

const MainMenu = () => {
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        const fetchMenuItems = async () => {
            try {
                const response = await axios.get(`${baseURL}items/header?fields=*.*`);
                if (response.data && Array.isArray(response.data.data)) {
                    setMenuItems(response.data.data);
                } else {
                    console.error("Invalid data format received from Directus.");
                }
            } catch (error) {
                console.error("Error fetching data from Directus:", error);
            }
        };

        fetchMenuItems();
    }, []);

    return (
        <nav className="main-menu d-none d-lg-block">
            <ul className="d-flex">
                {menuItems &&
                    menuItems.map((e) => (
                        <li key={e.id}>
                            {/* 1. Eğer PDF alanı doluysa, PDF linkini göster */}
                            {e?.pdf ? (
                                <a
                                    href={`${baseURL}assets/${e?.pdf.id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {e?.title}
                                </a>
                            ) : e?.link && e.link.startsWith("http") ? (
                                /* 2. Harici link kontrolü */
                                <a
                                    href={e?.link}
                                    target={e.target ? "_blank" : "_self"}
                                    rel="noopener noreferrer"
                                >
                                    {e?.title}
                                </a>
                            ) : (
                                /* 3. Dahili link veya link alanı boşsa ana sayfaya yönlendirme */
                                <Link to={e?.link || "/"}>
                                    {e?.title}
                                </Link>
                            )}
                        </li>
                    ))}
            </ul>
        </nav>
    );
};

export default MainMenu;
